import { render, staticRenderFns } from "./ivyobjectAE.vue?vue&type=template&id=661d2c79&"
import script from "./ivyobjectAE.vue?vue&type=script&lang=js&"
export * from "./ivyobjectAE.vue?vue&type=script&lang=js&"
import style0 from "./ivyobjectAE.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports